
import { StorageService } from './../../services/storage.service';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError, delay, finalize } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../services/userService/user.service';
import { RoutingService } from '../../services/routingService/routing.service';
import { CandidateService } from '../../services/candidate/candidate.service';
import { RefreshTokenService } from '../../services/refreshToken/refresh-token.service';
import { NgProgress } from 'ngx-progressbar';

@Injectable()
export class InterceptorService implements HttpInterceptor {
    
    constructor(
        private storageService: StorageService,
        public toaster: ToastrService,
        private userService: UserService,
        private router: Router,
        private tokenService: RefreshTokenService,
        private progressRef: NgProgress
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const checkExisting = this.tokenService.checkForDuplicateUrl(request.url);
        if (!checkExisting) {
            // this.userService.onUserLoginStateChange();
            return throwError(`Allready called ${JSON.stringify(request.url)}`);
        }
        if (request.url.endsWith('/refresh') || request.url.endsWith('/logout')) {
            this.tokenService.assignAllrequests(request.url);
        }
        let token;
        const acess_token = this.storageService.getData('access_token');
        if (acess_token) {
            token = request.clone({
                setHeaders: {
                    'Authorization': 'Bearer' + acess_token
                }
            });
        } else {
            token = request.clone({
                setHeaders: {
                }
            });
        }
        this.progressRef?.ref().start();
        return next.handle(token)
            .pipe(
                finalize(() => this.progressRef?.ref().complete()),
                map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    this.tokenService.removeUrlOnresponse(request.url);
                    if (event.body !== null && event.body.access_token !== undefined) {
                        this.storageService.setData('access_token', event.body.access_token);
                    }
                    if (event.headers.get('authorization')) {
                        this.storageService.setData('access_token', event.headers.get('authorization'));
                    }
                    return event;
                }
            }))
            .pipe(catchError((err: HttpEvent<any>) => {
                let message: string;
                if (err instanceof HttpErrorResponse) {
                    this.tokenService.removeUrlOnresponse(request.url);
                    if (err.error && err.error.message) {
                        message = err.error.message;
                        switch ((<HttpErrorResponse>err).status) {
                            case 402:
                                message = 'duplicate entry';
                                break;
                                case 409:
                                message = 'duplicate entry';
                                break;
                            case 500:
                                if (message === 'Token has expired and can no longer be refreshed') {
                                    this.userService.logOut().subscribe(() => {
                                        this.storageService.removeData('access_token');
                                        this.router.navigate(['/login']);
                                        this.userService.onUserLoginStateChange();
                                    });
                                }
                                break;
                            case 400:
                                message = '';
                                break;
                            case 401:
                                    this.storageService.removeData('access_token');
                                    this.router.navigate(['/login']);
                                    this.userService.onUserLoginStateChange();
                                // });
                                break;
                            case 403:
                                message = '';
                                break;
                            case 404:
                                if (message === 'User not found.') {
                                    this.toaster.error('User not found');
                                } else {
                                    this.toaster.error('Requested page is not found');
                                }
                                break;
                            case 504:
                                    this.toaster.error('Service not available, please try after sometime');
                                break;
                            case 412:
                                message = '';
                                Swal.fire('error', err.error.message, 'error');
                                break;
                            default:
                                return throwError(err);
                        }
                    }
                }
                return throwError(err);
            }));
    }
}
